var _linearGradient, _linearGradient2, _circle, _linearGradient3, _circle2, _g, _defs, _clipPath, _linearGradient4, _path, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPodcastbg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 500"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 5.281,
    y1: -1.468,
    x2: 746.354,
    y2: 502.581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#ffe7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffccaf"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 182,
    y1: 238.091,
    x2: 182,
    y2: 92.575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#ffe7dd",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7b8b"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.36,
    fill: "url(#podcastbg_svg__b)",
    cx: 182,
    cy: 179,
    r: 68
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 430.988,
    y1: 273.646,
    x2: 430.988,
    y2: 212.537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#ffe7dd",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc0a2"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__c)",
    cx: 430.988,
    cy: 237.498,
    r: 41.598
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "podcastbg_svg__d",
    cx: 569.34,
    cy: 176.917,
    r: 70.66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "podcastbg_svg__e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#podcastbg_svg__d",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#podcastbg_svg__e)",
    fill: "#FFACC9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M681.736-44.835l1.967 1.967-242.345 242.345-1.967-1.966zM681.737-31.482l1.966 1.967-242.344 242.344-1.967-1.966zM681.745-18.106l1.966 1.967-242.378 242.31-1.967-1.967zM681.744-4.753l1.967 1.967-242.378 242.31-1.967-1.967zM681.754 8.622l1.966 1.968-242.413 242.275-1.966-1.967zM681.737 21.931l1.966 1.966-242.344 242.345-1.967-1.967zM681.737 35.284l1.966 1.966-242.345 242.346-1.966-1.967zM681.737 48.637l1.966 1.966L441.36 292.948l-1.967-1.967zM681.737 61.99l1.967 1.966-242.345 242.345-1.967-1.966zM681.752 75.386l1.967 1.967L441.306 319.63l-1.967-1.967zM681.737 88.696l1.966 1.967L441.36 333.007l-1.967-1.966zM681.737 102.05l1.966 1.966L441.358 346.36l-1.966-1.966zM681.751 115.444l1.967 1.968-242.413 242.276-1.967-1.968zM681.738 128.755l1.966 1.967L441.36 373.066l-1.967-1.966zM681.738 142.108l1.966 1.967L441.36 386.42l-1.966-1.967zM681.738 155.461l1.966 1.967L441.36 399.772l-1.967-1.966zM681.738 168.814l1.966 1.967L441.36 413.126l-1.966-1.967z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "podcastbg_svg__f",
    d: "M0 0h750v500H0z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "podcastbg_svg__g"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#podcastbg_svg__f",
    overflow: "visible"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__h",
    gradientUnits: "userSpaceOnUse",
    x1: 7.609,
    y1: 373.656,
    x2: 423.109,
    y2: 373.656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8300"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#podcastbg_svg__g)",
    fill: "url(#podcastbg_svg__h)",
    d: "M7.609 443.581s92.995 19.499 169.491-37.498c76.497-56.997 127.494-65.997 223.489-40.498 95.995 25.498-139.493-104.995-244.487-52.498C51.106 365.585 7.609 443.581 7.609 443.581z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#podcastbg_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    fill: "#FFF",
    d: "M-19.39 181.094s91.495-71.996 193.49-9c101.995 62.997 209.989 100.495 269.986 68.997 59.997-31.499 64.497-34.498 145.493-46.498S666.076 89.599 735.072 65.6c68.997-23.999 65.997-4.5 65.997-4.5L804 335s-44.003-72.998-104-34-80.422 19.587-122.42 18.087-97.495 49.498-145.492 70.497c-47.998 20.998-125.994-61.497-196.491-38.999C165.101 373.084 75.105 460.08-8.89 425.582-92.886 391.083-56.888 268.09-56.888 268.09l37.498-86.996z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__i",
    gradientUnits: "userSpaceOnUse",
    x1: 100.504,
    y1: 257.35,
    x2: 779.148,
    y2: 257.35
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#38a6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#c31eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e100ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#podcastbg_svg__i)",
    d: "M100.504 404.876c2.402.577 36.628-32.327 64.032-41.689 39.807-13.601 84.881-42.546 126.523-21.591 18.335 9.227 29.413 9.26 48.992 9.608 17.648.314 29.021 11.076 43.546 19.819 34.068 20.506 68.827 27.196 106.789 18.792 32.679-7.233 49.988-34.483 66.252-62.406 7.96-13.665 16.665-29.291 30.825-37.31 13.351-7.561 26.694-3.554 41.25-3.821 28.697-.528 46.789-18.441 71.063-30.648 24.093-12.116 53.594-16.343 79.37-7.064-3.487-19.364-7.255-38.896-9.744-58.419-2.988-23.439 6.211-45.081 7.753-68.387-20.548-7.749-43.489-11.374-65.348-11.909-47.448-1.163-66.436 26.396-88.347 64.08-17.229 29.63-39.576 54.517-68.405 74.165-26.377 17.977-59.729 38.228-90.034 46.687-21.322 5.952-44.333 6.768-66.049.247-23.137-6.946-46.001-15.559-69.127-22.825-28.78-9.043-51.523-29.67-79.432-40.41-29.643-11.407-51.451-.885-71.027 21.343-36.558 41.509-78.882 151.738-78.882 151.738z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__j",
    gradientUnits: "userSpaceOnUse",
    x1: -82.387,
    y1: 239.337,
    x2: 784.695,
    y2: 239.337
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#ff0986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#ff207a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ff4665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#ff7a48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9b36"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#podcastbg_svg__j)",
    d: "M-8.89 445.081c20.629 1.469 43.678 6.911 63.565 1.501 18.953-5.156 37.209-13.216 53.325-24.508 18.557-13.004 30.384-33.918 48.057-46.008 41.136-28.141 100.495-110.592 157.617-58.662 9.585 8.714 20.888 23.025 33.242 27.804 10.997 4.253 23.75.314 35.176.3 16.385-.02 30.71 2.063 46.713-3.08 22.767-7.317 41.815-23.063 58.65-38.874 18.826-17.682 28.881-35.978 55.817-40.048 19.646-2.97 25.418-17.473 33.948-34.548 8.951-17.92 20.052-34.659 28.53-52.745 11.01-23.487 17.053-56.048 40.175-71.042 36.043-23.373 134.492-9.132 134.526 46.02 6.948-25.138 6.439-35.244-9.691-54.766-13.322-16.123-16.976-27.857-19.179-48.831C701.56 26.655 632.729 15.472 594.91 64.337c-13.895 17.953-21.013 38.042-21.896 60.587-.858 21.937 6.708 51.16-2.246 71.855-3.63 8.39-12.609 14.575-18.124 21.75-9.024 11.741-15.175 16.554-29.397 22.024-14.998 5.77-31.069 9.167-46.979 5.151-8.09-2.042-13.307-5.024-21.94-4.203-7.964.758-15.214 4.77-23.443 3.865C398.675 241.828 385.17 204.044 366 183c-21.092-23.154-72.275-36.854-102-34-73.947 7.098-95.193 63.019-123.638 122.623-17.608 36.896-74.382 100.184-121.17 90.667-54.554-11.097-91.926 6.031-101.578 58.792 26.966 4.727 46.529 19.272 73.496 23.999z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__k",
    gradientUnits: "userSpaceOnUse",
    x1: 417.088,
    y1: 365.01,
    x2: 417.088,
    y2: 45.081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a42f7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#ac3578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#c44466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#e95c47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6a36"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "url(#podcastbg_svg__k)",
    d: "M669.076 70.1c-86.996 3-73.497 86.996-86.996 121.494-13.499 34.499-3 52.498-50.997 55.498-47.998 3-41.998 29.998-65.997 46.497-80.996 37.498-68.996-5.999-193.49-35.998-124.494-29.999-218.99 161.991-218.99 161.991l5.521 26.025c17.715-5.175 34.738-12.929 49.873-23.533 18.557-13.004 30.384-33.918 48.057-46.008 41.136-28.141 100.495-110.592 157.617-58.662 9.585 8.714 20.888 23.025 33.242 27.804 10.997 4.253 23.75.314 35.176.3 16.385-.02 30.71 2.063 46.713-3.08 22.767-7.317 41.815-23.063 58.65-38.874 18.826-17.682 28.881-35.977 55.817-40.048 19.646-2.97 25.418-17.473 33.948-34.548 8.951-17.92 20.052-34.659 28.53-52.745 11.01-23.487 17.053-56.048 40.175-71.042 31.93-20.706 112.823-11.886 130.896 28.739l4.748-11.313c.001 0-25.498-55.497-112.493-52.497z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__l",
    gradientUnits: "userSpaceOnUse",
    x1: -62.628,
    y1: 242.47,
    x2: 876.477,
    y2: 242.47
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.049,
    stopColor: "#03def9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0ab9e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#167dcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#262ca9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#2e0095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#360099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopColor: "#4c00a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#6f00b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#a100cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#df00ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#podcastbg_svg__l)",
    d: "M-23.734 244.096c19.585-17.583 42.947-31.596 67.186-41.667 50.795-21.104 101.407-13.779 149.375 6.741 32.598 13.944 49.606 44.987 77.097 67.497 17.46 14.296 39.118 23.378 61.109 28.077 51.741 11.055 87.328-14.028 124.106-47.849 25.493-23.443 54.906-45.627 90.668-35.441 28.354 8.076 54.524 9.52 83.406 1.282 51.928-14.812 64.372-73.21 90.359-114.148 10.396-16.378 16.652-31.581 32.582-43.802 21.896-16.799 48.631-25.259 75.646-29.28 1.824 11.199 2.354 28.168 8.699 38.097 5.555 8.692 17.365 14.65 25.179 20.99 21.649 17.563 16.981 28.193 2.379 48.034-15.672 21.294-13.953 29.825-9.875 54.867l9.062 55.635c-41.457-26.666-104.024-59.911-152.971-43.472-42.477 14.266-84.915 56.146-132.729 49.472-13.024-1.817-22.59-12.739-35.591-13.855-24.475-2.101-40.211 30.169-54.853 42.179-25.059 20.556-60.273 48.036-95.485 54.284-30.38 5.391-51.882-12.362-77.269-25.11-63.131-31.703-179.069 4.395-205.875 70.281-30.672 75.391-108.657 75.281-171.1 38.29l38.895-181.102z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__m",
    gradientUnits: "userSpaceOnUse",
    x1: -25.047,
    y1: 295.269,
    x2: 864.369,
    y2: 295.269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.049,
    stopColor: "#03def9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0ab9e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#167dcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#262ca9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#2e0095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#360097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopColor: "#4c019b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#6f02a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#a103ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#df05b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff06bf"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    fill: "url(#podcastbg_svg__m)",
    d: "M487.101 287.45c14.642-12.01 30.378-44.28 54.853-42.179 13.001 1.116 22.566 12.038 35.591 13.855 47.813 6.674 90.253-35.207 132.729-49.472 48.946-16.438 111.514 16.806 152.971 43.472l-8.89-54.58c-3.999-24.554-6.425-35.004 10.015-56.304-82.075-12.91-147.648 39.748-209.305 81.548-35.068 23.775-70.722 10.434-111.133 10.765-62.428.511-83.188 78.804-138.54 98.705-34.094 12.259-62.958-7.112-92.027-22.56-46.613-24.771-98.206-43.836-150.706-48.314C60.913 253.707.915 359.313-25.047 442.363c57.973 19.748 109.589 3.035 133.519-55.458 26.987-65.965 142.745-101.984 205.875-70.282 25.386 12.749 46.888 30.502 77.269 25.111 35.211-6.248 70.427-33.729 95.485-54.284z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#podcastbg_svg__g)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "podcastbg_svg__n",
    cx: 203.34,
    cy: 372.918,
    r: 70.66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "podcastbg_svg__o"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#podcastbg_svg__n",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#podcastbg_svg__o)",
    fill: "#FFACC9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.728 151.15l1.967 1.967-242.31 242.38-1.968-1.968zM315.75 164.536l1.968 1.968-242.379 242.31-1.967-1.968zM315.729 177.856l1.967 1.967-242.31 242.38-1.968-1.968zM315.729 191.21l1.967 1.966-242.31 242.38-1.968-1.967zM315.75 204.594l1.968 1.968-242.38 242.31-1.967-1.967zM315.729 217.916l1.967 1.967-242.31 242.38-1.968-1.967zM315.73 231.27l1.967 1.966-242.311 242.38-1.967-1.967zM315.73 244.622l1.967 1.967-242.31 242.38-1.968-1.967zM315.73 257.975l1.967 1.967-242.31 242.38-1.968-1.967zM315.75 271.359l1.968 1.968-242.38 242.31-1.967-1.968zM315.73 284.682l1.968 1.967-242.31 242.379-1.968-1.967zM315.731 298.035l1.968 1.967-242.311 242.38-1.968-1.968zM315.75 311.417l1.968 1.968-242.379 242.31-1.967-1.968zM315.731 324.742l1.967 1.967-242.31 242.379-1.968-1.967zM315.75 338.122l1.968 1.969L75.339 582.4l-1.968-1.968zM315.732 351.448l1.967 1.967L75.39 595.794l-1.967-1.967zM315.732 364.801l1.968 1.967-242.311 242.38-1.968-1.967z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__p",
    gradientUnits: "userSpaceOnUse",
    x1: 624.828,
    y1: 352.93,
    x2: 624.828,
    y2: 261.488
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#ffe7dd",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc0a2"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__p)",
    cx: 624.828,
    cy: 298.838,
    r: 62.247
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__q",
    gradientUnits: "userSpaceOnUse",
    x1: 96.854,
    y1: 393.356,
    x2: 96.854,
    y2: 284.286
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#ffe7dd",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ffdbcc",
    stopOpacity: 0.178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#ffccb5",
    stopOpacity: 0.475
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#ffc3a7",
    stopOpacity: 0.756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc0a2"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__q)",
    cx: 96.854,
    cy: 328.837,
    r: 74.246
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__r",
    gradientUnits: "userSpaceOnUse",
    x1: 234.848,
    y1: 316.879,
    x2: 234.848,
    y2: 258.489
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#ffe7dd",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ffdbcc",
    stopOpacity: 0.178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#ffccb5",
    stopOpacity: 0.475
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#ffc3a7",
    stopOpacity: 0.756
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc0a2"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__r)",
    cx: 234.848,
    cy: 282.339,
    r: 39.748
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__s",
    gradientUnits: "userSpaceOnUse",
    x1: 690.824,
    y1: 166.887,
    x2: 690.824,
    y2: 108.496
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#ffe7dd",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#ffecda",
    stopOpacity: 0.133
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#fffad1",
    stopOpacity: 0.596
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffce"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__s)",
    cx: 690.824,
    cy: 132.346,
    r: 39.748
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M102.163 258.83c0-1.013.824-1.83 1.837-1.83a1.829 1.829 0 110 3.657 1.83 1.83 0 01-1.837-1.827zM86.525 258.83c0-1.013.818-1.83 1.832-1.83a1.829 1.829 0 110 3.657 1.825 1.825 0 01-1.832-1.827zM102.163 247.134a1.835 1.835 0 013.67 0 1.832 1.832 0 01-1.833 1.831 1.833 1.833 0 01-1.837-1.831zM86.525 247.134a1.832 1.832 0 113.663.001 1.832 1.832 0 01-3.663-.001zM102.163 234.873a1.836 1.836 0 013.67 0 1.834 1.834 0 01-3.67 0zM86.525 234.873a1.83 1.83 0 113.662 0 1.83 1.83 0 01-3.662 0zM72.152 258.83c0-1.013.818-1.83 1.833-1.83 1.015 0 1.83.817 1.83 1.83a1.823 1.823 0 01-1.83 1.827 1.826 1.826 0 01-1.833-1.827zM56.513 258.83a1.833 1.833 0 013.665 0 1.83 1.83 0 01-1.834 1.827 1.825 1.825 0 01-1.831-1.827zM72.152 247.134a1.832 1.832 0 113.663.001 1.832 1.832 0 01-3.663-.001zM56.513 247.134a1.831 1.831 0 113.663 0 1.831 1.831 0 01-3.663 0zM72.152 234.873a1.831 1.831 0 113.662 0 1.831 1.831 0 01-3.662 0zM56.513 234.873a1.83 1.83 0 011.831-1.831c1.009 0 1.834.821 1.834 1.831a1.835 1.835 0 01-1.834 1.831 1.83 1.83 0 01-1.831-1.831z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 418.128,
    cy: 363,
    r: 2.376
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.252,
    cy: 363,
    r: 2.376
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.376,
    cy: 363,
    r: 2.376
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "podcastbg_svg__t",
    cx: 759.36,
    cy: 191.926,
    r: 56.034
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "podcastbg_svg__u"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#podcastbg_svg__t",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#podcastbg_svg__u)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M848.513 16.077l1.56 1.56-192.21 192.155-1.56-1.56zM848.49 26.66l1.56 1.56-192.182 192.182-1.56-1.56zM848.513 37.256l1.56 1.56-192.21 192.155-1.56-1.56zM848.513 47.845l1.56 1.56-192.21 192.155-1.559-1.56zM848.49 58.427l1.56 1.56L657.868 252.17l-1.56-1.56zM848.537 69.032l1.56 1.56L657.86 262.72l-1.56-1.56zM848.49 79.606l1.56 1.56-192.182 192.182-1.56-1.56zM848.49 90.195l1.56 1.56-192.182 192.182-1.56-1.56zM848.538 100.8l1.56 1.56L657.86 294.487l-1.56-1.56zM848.49 111.373l1.56 1.56L657.87 305.115l-1.56-1.56zM848.49 121.962l1.56 1.56L657.87 315.704l-1.56-1.56zM848.539 132.568l1.56 1.56-192.237 192.128-1.56-1.56zM848.49 143.14l1.56 1.56L657.87 336.884l-1.56-1.56zM848.49 153.73l1.56 1.56L657.868 347.47l-1.56-1.56zM848.54 164.336l1.559 1.56-192.236 192.128-1.56-1.56zM848.491 174.908l1.56 1.56L657.87 368.65l-1.56-1.56zM848.49 185.497l1.56 1.56L657.87 379.24l-1.56-1.56z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "podcastbg_svg__v",
    cx: -2.64,
    cy: 353.926,
    r: 76.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "podcastbg_svg__w"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#podcastbg_svg__v",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#podcastbg_svg__w)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.273 113.412l2.134 2.134-262.853 262.852-2.134-2.134zM119.245 127.867L121.38 130l-262.778 262.927-2.134-2.133zM119.273 142.378l2.134 2.134-262.853 262.852-2.134-2.134zM119.273 156.86l2.134 2.135-262.852 262.852-2.134-2.134zM119.273 171.343l2.134 2.134-262.852 262.853-2.134-2.134zM119.248 185.802l2.134 2.133-262.779 262.926-2.133-2.132zM119.274 200.31l2.134 2.133-262.853 262.853-2.134-2.134zM119.274 214.792l2.134 2.134-262.853 262.853-2.134-2.134zM119.25 229.252l2.134 2.133-262.778 262.927-2.134-2.133zM119.273 243.759l2.134 2.134-262.852 262.852-2.134-2.134zM119.274 258.242l2.134 2.134-262.853 262.852-2.134-2.134zM119.274 272.724l2.134 2.134-262.852 262.852-2.134-2.134zM119.274 287.208l2.134 2.134-262.853 262.852-2.134-2.134zM119.274 301.69l2.134 2.135-262.852 262.852-2.134-2.134zM119.254 316.154l2.133 2.133-262.778 262.927-2.134-2.133zM119.274 330.656l2.134 2.134-262.852 262.853-2.134-2.134zM119.275 345.14l2.134 2.133-262.853 262.853-2.134-2.134z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__x",
    gradientUnits: "userSpaceOnUse",
    x1: 88.075,
    y1: 126.027,
    x2: 76.075,
    y2: 184.524
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8300"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__x)",
    cx: 81.855,
    cy: 156.345,
    r: 18.749
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__y",
    gradientUnits: "userSpaceOnUse",
    x1: 584.55,
    y1: 271.519,
    x2: 572.55,
    y2: 330.016
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8300"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__y)",
    cx: 578.33,
    cy: 301.838,
    r: 18.749
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__z",
    gradientUnits: "userSpaceOnUse",
    x1: 540.577,
    y1: 301.024,
    x2: 538.177,
    y2: 312.724
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8300"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__z)",
    cx: 539.332,
    cy: 307.088,
    r: 3.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__A",
    gradientUnits: "userSpaceOnUse",
    x1: 306.072,
    y1: 243.26,
    x2: 297.432,
    y2: 285.378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8300"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__A)",
    cx: 301.594,
    cy: 265.09,
    r: 13.499
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__B",
    gradientUnits: "userSpaceOnUse",
    x1: 272.086,
    y1: 222.39,
    x2: 268.246,
    y2: 241.108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8300"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__B)",
    cx: 270.096,
    cy: 232.091,
    r: 6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__C",
    gradientUnits: "userSpaceOnUse",
    x1: 309.313,
    y1: 357.766,
    x2: 297.314,
    y2: 416.262
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2f7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#ff3879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#ff4f6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#ff7450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9b36"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__C)",
    cx: 303.094,
    cy: 388.084,
    r: 18.749
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__D",
    gradientUnits: "userSpaceOnUse",
    x1: 579.3,
    y1: 66.779,
    x2: 567.3,
    y2: 125.277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68c5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3239ff"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__D)",
    cx: 573.081,
    cy: 97.098,
    r: 18.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__E",
    gradientUnits: "userSpaceOnUse",
    x1: 700.552,
    y1: 238.761,
    x2: 691.913,
    y2: 280.877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9b36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#ff7a48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ff4665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#ff207a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#ff0986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff008b"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__E)",
    cx: 696.074,
    cy: 260.59,
    r: 13.499
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__F",
    gradientUnits: "userSpaceOnUse",
    x1: 662.066,
    y1: 286.886,
    x2: 658.226,
    y2: 305.605
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9b36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#ff7a48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ff4665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#ff207a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#ff0986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff008b"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__F)",
    cx: 660.076,
    cy: 296.588,
    r: 6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__G",
    gradientUnits: "userSpaceOnUse",
    x1: 571.566,
    y1: 36.047,
    x2: 565.807,
    y2: 64.126
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68c5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3239ff"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__G)",
    cx: 568.581,
    cy: 50.601,
    r: 9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__H",
    gradientUnits: "userSpaceOnUse",
    x1: 356.58,
    y1: 365.456,
    x2: 351.78,
    y2: 388.856
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2f7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#ff3879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#ff4f6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#ff7450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9b36"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__H)",
    cx: 354.092,
    cy: 377.584,
    r: 7.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "podcastbg_svg__I",
    gradientUnits: "userSpaceOnUse",
    x1: 113.344,
    y1: 116.182,
    x2: 109.024,
    y2: 137.242
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8300"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#podcastbg_svg__I)",
    cx: 111.104,
    cy: 127.097,
    r: 6.75
  }))));
}
export default SvgPodcastbg;